import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/MyHome.vue'; 
const router = createRouter({
    history: createWebHistory(),
    routes: [
      { path: '/', component: Home },
      // 其他路由配置
    ],
  });

  export default router;